/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AlertingData } from './AlertingData';
import {
    AlertingDataFromJSON,
    AlertingDataFromJSONTyped,
    AlertingDataToJSON,
    AlertingDataToJSONTyped,
} from './AlertingData';

/**
 * Serializer for sensor data request status and results.
 * @export
 * @interface AlertingDataRequest
 */
export interface AlertingDataRequest {
    /**
     * 
     * @type {Array<AlertingData>}
     * @memberof AlertingDataRequest
     */
    responseData?: Array<AlertingData> | null;
    /**
     * 
     * @type {string}
     * @memberof AlertingDataRequest
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof AlertingDataRequest
     */
    errorMessage?: string | null;
}

/**
 * Check if a given object implements the AlertingDataRequest interface.
 */
export function instanceOfAlertingDataRequest(value: object): value is AlertingDataRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function AlertingDataRequestFromJSON(json: any): AlertingDataRequest {
    return AlertingDataRequestFromJSONTyped(json, false);
}

export function AlertingDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertingDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'responseData': json['response_data'] === undefined ? undefined : json['response_data'] === null ? null : ((json['response_data'] as Array<any>).map(AlertingDataFromJSON)),
        'status': json['status'],
        'errorMessage': json['error_message'] === undefined ? undefined : json['error_message'] === null ? null : json['error_message'],
    };
}

export function AlertingDataRequestToJSON(json: any): AlertingDataRequest {
    return AlertingDataRequestToJSONTyped(json, false);
}

export function AlertingDataRequestToJSONTyped(value?: AlertingDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'response_data': value['responseData'] == null ? undefined : ((value['responseData'] as Array<any>).map(AlertingDataToJSON)),
        'status': value['status'],
        'error_message': value['errorMessage'],
    };
}

